module.exports = __webpack_public_path__ + "static/5-kahncerf-1974-4c0d546e12a5c38bcb412ff21088ebc6.jpg";